export const testimonials = [

    {role:"Quality Assurance Engineer, eTranzact PLC. ",
    name:"Ugo Kaine", 
    body:"Just the right attitude and creativity to get the job done. Not many devs have that you know.", 
    avatar:"/images/ugo.jpg",
    connect:"https://www.linkedin.com/in/chibugo-kaine-6363ab125/"
   
   },



   {role:"C.E.O, MiddleTrust PLC. ",
   name:"Efe Ojadua", 
   body:"Worked in him at middletrust in building the best Escrow platform in Nigeria, you really want to see what this guy has to offer, you know, he has that eye for the exceptional. Never gives up until he gets the results.", 
   avatar:"/images/efe.jfif",
   connect:"https://www.linkedin.com/in/ojadua-efe/"
  
  },

  {role:"Senior software Developer, Interswitch. ",
  name:"Mishael Harry", 
  body:"Collaborated in developing a hospital Management Sysytem for a client, Quite creative developer. This guy is the real deal. Just the right work ethics and dedication to get the job done.", 
  avatar:"/images/mishy.jpg",
  connect:"https://www.linkedin.com/in/mishael-harry-2b228b120/"
 
 },

   {role:"Quality Assurance Engineer, Union Bank, Nigeria. ",
   name:"Francis Arharire", 
   body:"Quite a creative and disciplined developer, always keeping to timelines", 
   avatar:"/images/franco.jfif",
   connect:"https://www.linkedin.com/in/arharhire-francis-73079612b/"
  
  },
]